import React from 'react'

const IconArrow = ({fillColor,style}) => {
  return (
 
   <svg xmlns="http://www.w3.org/2000/svg" className={'search-icon ' + fillColor} style={style}  viewBox="0 -960 960 960"><path d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z"/>
            </svg>
  )
}
export default IconArrow